import { type FC, type ComponentProps } from 'react';

import { Indicator } from '@radix-ui/react-radio-group';

import { radioIndicatorStyle } from './RadioIndicator.css';
import { getClassNames } from '../../util/css';

type RadioIndicatorProps = ComponentProps<typeof Indicator>;

/**
 * Renders when the radio item is in a checked state.
 */
export const RadioIndicator: FC<RadioIndicatorProps> = ({ className, ...props }) => (
  <Indicator className={getClassNames(radioIndicatorStyle, className)} {...props} />
);
